<template>
  <div>
    <vs-row class="mb-5">
     <vs-input
        icon="search"
        icon-after="true"  
        class="inputx tree-search-input mr-2"
        v-model.lazy="searchword"
        @input="search"
        :placeholder="$t('SearchPlaceholder')"
      />
    </vs-row>
    <v-tree
      ref="tree"
      @node-click="check"
      :canDeleteRoot="false"
      :data="treeData"
      :draggable="false"
      :halfcheck="false"
      :tpl="tpl"
      :multiple="false"
    />
  </div>
</template>
<script>
import { VTree } from "vue-tree-halower";
import router from '../../../router'

export default {
  data() {
    return {
      searchword: "",
      treeData: [
        {
          title: "OPEX",
          i18n : "ABC.OPEX.Title",
          link: "/abc/kpi/opex",
          expanded: true,
          children: [
            {
              title: "Open Pit Mining",
              i18n : "ABC.OPEX.OPMining"
            },
            {
              title : "Underground Mining",
              i18n : "ABC.OPEX.UGMining",
              link: "/abc/kpi/opex/ugmining",
              expanded: true,
              children: [
                {
                  title : "Development",
                  i18n : "ABC.Development.ShortTitle",
                  expanded: true,
                  link: "/abc/kpi/opex/ugmining/development",
                  children: [
                    {
                      title : "Drilling",
                      i18n : "ABC.Development.Drilling",
                      link: "/abc/kpi/opex/ugmining/development/drilling"
                    },
                    {
                      title: "Blasting",
                      i18n : "ABC.Blasting"
                    },
                    {
                      title: "Mucking",
                      i18n : "ABC.Mucking"
                    },
                    {
                      title: "Hauling",
                      i18n : "ABC.Hauling"
                    }
                  ]
                },
                {
                  title: "Production",
                  i18n : "ABC.Production"
                },
                {
                  title: "Services",
                  i18n : "ABC.Services"
                },
                {
                  title: "Maintenance",
                  i18n : "ABC.Maintenance"
                }
              ]
            },
            {
              title: "Heap Leach Processing",  
              i18n : "ABC.OPEX.HLProcessing"
            },
            {
              title: "Mill Processing",
              i18n : "ABC.OPEX.MillProcessing"
            }
          ]
        }
      ]
    };
  },
  methods: {
    tpl (node) {
      const titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      return <span  class={titleClass} style="user-select: none;" onClick={() => {
        this.$refs.tree.nodeSelected(node)
      }}>
        { node.i18n ? this.$t(node.i18n) : node.title }
      </span>
    },
    search() {
      this.$refs.tree.searchNodes(this.searchword);
    },
    check(item) {
      if (item.link) {
        router.push({ path: item.link }); 
        this.$emit("kpiSelected");
      }
    }
  },
  components: {
    VTree
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";

.tree-search-input {
  width: 100%; 
}
</style>